import { atom } from "jotai";

/**
 * Longest dimension (`long_axis_mm`) of a loaded rdn60 stone overlay, keyed by
 * the bare `study_uid` it belongs to so a stale value from a previously-open
 * case can't leak into the next one.
 *
 * Written by `useSavedMaskOverlay` once the saved labeling annotation arrives;
 * read by `PrototypeReport` to inject the measurement into the kidneys-ureters
 * stone finding. See #654, which shipped it (the spec doc it cited was never committed).
 */
export interface StoneOverlayMeasurement {
  /** Bare study_instance_uid the measurement belongs to. */
  studyUid: string;
  /** Longest stone dimension in mm (max long_axis_mm across saved annotations). */
  longAxisMm: number;
}

export const stoneOverlayMeasurementAtom = atom<StoneOverlayMeasurement | null>(null);
